import styled from 'styled-components';
import { OrderPanelStyled, PriceCss } from '../OrderPanelStyled';
import { rem } from 'polished';

export const OrderPanelStyledDS = styled(OrderPanelStyled)`
    background: ${({ theme }) => theme.colors.grey4};

    &.isShowPriceExcludedVAT-panel {
        .currencyLabel__suffix--OTR {
            font-size: ${({ theme }) => theme.fontSizes.h6};
        }
    }

    .wrapper {
        .section {
            border-color: ${({ theme }) => theme.colors.grey11} !important;
            border-width: 1px !important;

            .order-panel-price-container {
                ${PriceCss}
                .calculator {
                    .txt {
                        font-size: ${({ theme }) => theme.fontSizes.h5};
                    }
                    .linkIcon {
                        svg {
                            path {
                                fill: ${({ theme }) => theme.colors.black};
                            }
                        }
                    }
                }
                .content {
                    .header {
                        font-size: ${rem(14)};
                    }

                    .body {
                        .body-wrapper {
                            .price {
                                font-size: ${({ theme }) => theme.fontSizes.h5};
                            }

                            .footer {
                                font-size: ${rem(14)};
                                max-width: ${rem(230)};

                                .financeContainer-price-financeQuoteLink {
                                    font-size: ${rem(14)};
                                }
                            }
                            .infoIcon {
                                top: 0;

                                .icon-wrapper {
                                    padding-top: unset;
                                }

                                svg {
                                    g {
                                        line,
                                        circle {
                                            stroke: ${({ theme }) => theme.colors.black};
                                        }
                                    }
                                }
                            }
                            .or {
                                line-height: ${rem('19px')};
                            }
                        }
                    }
                }
            }
        }

        .section-divider {
            background: ${({ theme }) => theme.colors.grey11};
        }

        .desktopContactSection {
            .modalLink {
                color: ${({ theme }) => theme.colors.black2};

                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.black2};
                        stroke: ${({ theme }) => theme.colors.black2};
                    }
                }

                &:hover,
                &:focus-visible {
                    border-bottom: 1px solid ${({ theme }) => theme.colors.black2};
                }
            }

            .phoneLink {
                color: ${({ theme }) => theme.colors.black2};
            }
        }
    }

    .mobileContactSection {
        padding: ${rem('10px')};
        background: ${({ theme }) => theme.colors.black1};
    }
`;
